import { Button, HStack, useDisclosure } from '@chakra-ui/react';
import { useEffect, useState, type FC } from 'react';

import { MobileDrawer } from '$/components/common/Drawer/MobileDrawer';
import { Icon } from '$/components/common/Icon';
import { MobileFilter } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileFilter';
import { MobileFilterDrawerContent } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileFilterDrawerContent';
import { t } from '$/components/core/Localization/i18nInstance';
import { useFilterOptions } from '$/hooks/data/useFilterOptions';
import { useIsMobile } from '$/hooks/useIsMobile';

interface Props {
  amount?: number;
  allowedFilters?: string[];
}

export const MobileFilterDrawer: FC<Props> = ({ amount, allowedFilters }) => {
  const isMobile = useIsMobile();

  const { data: filter } = useFilterOptions();
  const collectionFilter = filter?.general.find(
    (f) => f.searchField === 'collection',
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [subFilter, setSubFilter] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen && subFilter) setSubFilter(null);
  }, [isOpen, subFilter]);

  useEffect(() => {
    if (!isMobile && isOpen) onClose();
  }, [isMobile, isOpen, onClose]);

  return (
    <>
      <HStack>
        {collectionFilter && (
          <MobileFilter
            width='auto'
            flexGrow='5'
            filterGroup={collectionFilter}
            filterIcon='chevron_down'
            onSingleFilterSelected={(subFilter) => {
              setSubFilter(subFilter);
              onOpen();
            }}
          />
        )}

        <Button
          px='4'
          py='2'
          color='textButton.color'
          fontSize='sm'
          bg='background'
          borderWidth='1px'
          borderColor='border'
          borderRadius='8px'
          _hover={{ bg: 'background' }}
          _active={{ bg: 'background' }}
          onClick={onOpen}
          rightIcon={<Icon icon='filter_alt' boxSize='14px' />}
        >
          {t('dashboard.collection.filter.mobile.filterButton')}
        </Button>
      </HStack>

      <MobileDrawer isOpen={isOpen} onClose={onClose}>
        <MobileFilterDrawerContent
          amount={amount}
          allowedFilters={allowedFilters}
          onClose={onClose}
          setSubFilter={setSubFilter}
          subFilter={subFilter}
        />
      </MobileDrawer>
    </>
  );
};
